import videoLoader from '../../../../../../src24/js/modules/videoLoader';

window.addEventListener('load', () => {
    videoLoader.init();
}, false);
